import { all, fork } from 'redux-saga/effects';
import { previewSaga } from './preview';
import { tokenSaga } from './token';
import { nextPageSaga } from './next';
import { pageSaga } from './page';
import { verificationSaga } from './verification';
import { registerSaga } from './register';
import { responseSaga } from './response';
import { closeSaga } from './close';
import { homeSaga } from './home';

export default function* assetSaga() {
  yield all([
    fork(previewSaga),
    fork(tokenSaga),
    fork(nextPageSaga),
    fork(pageSaga),
    fork(verificationSaga),
    fork(registerSaga),
    fork(responseSaga),
    fork(closeSaga),
    fork(homeSaga),
  ]);
}
